import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchConfiguration } from "../api/configuration.api";

const useConfiguration = () => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["configuration"],
    queryFn: () => fetchConfiguration(bearerToken),
  });

  const fetchConfigrationData = async () => {
    await refetch();
  };

  return {
    configurationData: data,
    configurationError: error,
    isLoadingConfiguration: isLoading,
    fetchConfigrationData,
  };
};

export default useConfiguration;
